// https://davidwalsh.name/javascript-debounce-function
// https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf

export default function copyToClipboard(text) {
    var copyText = document.querySelector(".copy-to-clipboard");
    if(copyText){
      copyText.addEventListener("click", function(){
        navigator.clipboard.writeText(window.location.href);
      })

    }
}
